<template>
  <section id="cars">
    <h3>Cars</h3>
    <Route v-if="!isSavedRoute" v-bind="$attrs" v-model:cars="cars" v-model:is-saved-route="isSavedRoute" @error="$emit('error', $event)" @back="$emit('back', $event)" @scroll="$emit('scroll', $event)" />
    <BookSummary v-if="isSavedRoute" v-bind="$attrs" v-model:cars-other="cars.other" v-model:is-saved-route="isSavedRoute" :cars="cars" @complete="complete" @scroll="$emit('scroll', $event)" />
  </section>
</template>

<script setup>
import { ref, computed } from "vue";
import DateTime from "../utils/datetime";
import Route from "./TripNewBookCarsRoute.vue";
import BookSummary from "./TripNewBookCarsSummary.vue";

const emit = defineEmits(["error", "back", "scroll", "update:cars", "update:sectionsCarsDateStart", "update:sectionsCarsDateEnd", "update:sectionsCarsDescription", "update:sectionsCarsDestination", "update:sectionsCarsIsComplete"]);

const cars = ref({
  isReturnDifferentPlace: false,
  route: [
    {
      dateCollect: "",
      dateCollectTime: "12:00pm",
      dateReturn: "",
      dateReturnTime: "12:00pm",
      placeCollect: "",
      placeReturn: "",
    },
  ],
});

const isSavedRoute = ref(false);

const { utilDateISO8601, utilDateFlightfoxShort } = DateTime();

const carsDateStart = computed(() => utilDateISO8601(cars.value.route[0].dateCollect));

const carsDateEnd = computed(() => utilDateISO8601(cars.value.route[cars.value.route.length - 1].dateReturn));

const carsDescription = computed(() => {
  let desc = "\r\n\r\n***\r\n\r\nCARS\r\n\r\n";
  desc += carsRouteToText.value;
  desc += "\r\n\r\nOther: " + (cars.value.other ? cars.value.other : "NA");
  return desc;
});

const carsDestination = computed(() => {
  const destArray = cars.value.route.map(leg => leg.placeCollect.name);
  if (destArray.length === 1) return destArray[0];
  if (destArray.length > 3) return "Multiple Cities";
  const destLast = destArray.pop();
  const destString = destArray.join(", ");
  return destString + " & " + destLast;
});

const carsRouteToText = computed(() => {
  return cars.value.route
    .map(data => {
      let leg = "";
      if (data.dateCollect) {
        const placeReturn = data.placeReturn === "" ? "" : ` (Return: ${data.placeReturn.name})`;
        const dtCollect = `${utilDateFlightfoxShort(data.dateCollect)} ${data.dateCollectTime}`;
        const dtReturn = `${utilDateFlightfoxShort(data.dateReturn)} ${data.dateReturnTime}`;
        leg = `${data.placeCollect.name}${placeReturn}\r\nPick-up: ${dtCollect}\r\nDrop-off: ${dtReturn}\r\n\r\n`;
      }
      return leg;
    })
    .join("")
    .trim();
});

const complete = () => {
  emit("update:sectionsCarsDateStart", carsDateStart.value);
  emit("update:sectionsCarsDateEnd", carsDateEnd.value);
  emit("update:sectionsCarsDescription", carsDescription.value);
  emit("update:sectionsCarsDestination", carsDestination.value);
  emit("update:cars", cars.value);
  emit("update:sectionsCarsIsComplete", true);
  emit("scroll");
};
</script>
